"use strict";

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Defines values for EnableState.
 * Possible values include: 'Disabled', 'Enabled'
 * There could be more values for this enum apart from the ones defined here.If
 * you want to set a value that is not from the known values then you can do
 * the following:
 * let param: EnableState =
 * <EnableState>"someUnknownValueThatWillStillBeValid";
 * @readonly
 * @enum {string}
 */
var EnableState;
(function (EnableState) {
  /**
   * Indicates a disabled state
   */
  EnableState["Disabled"] = "Disabled";
  /**
   * Indicates an enabled state
   */
  EnableState["Enabled"] = "Enabled";
})(EnableState = exports.EnableState || (exports.EnableState = {}));
/**
 * Defines values for CoreFamily.
 * Possible values include: 'Standard', 'GPU'
 * There could be more values for this enum apart from the ones defined here.If
 * you want to set a value that is not from the known values then you can do
 * the following:
 * let param: CoreFamily = <CoreFamily>"someUnknownValueThatWillStillBeValid";
 * @readonly
 * @enum {string}
 */
var CoreFamily;
(function (CoreFamily) {
  /**
   */
  CoreFamily["Standard"] = "Standard";
  /**
   */
  CoreFamily["GPU"] = "GPU";
})(CoreFamily = exports.CoreFamily || (exports.CoreFamily = {}));
/**
 * Defines values for IdleShutdownMode.
 * Possible values include: 'None', 'OnDisconnect', 'NotSupported'
 * There could be more values for this enum apart from the ones defined here.If
 * you want to set a value that is not from the known values then you can do
 * the following:
 * let param: IdleShutdownMode =
 * <IdleShutdownMode>"someUnknownValueThatWillStillBeValid";
 * @readonly
 * @enum {string}
 */
var IdleShutdownMode;
(function (IdleShutdownMode) {
  /**
   * Do not shutdown VMs on idle.
   */
  IdleShutdownMode["None"] = "None";
  /**
   * Shutdown VMs after remote connection is disconnected.
   */
  IdleShutdownMode["OnDisconnect"] = "OnDisconnect";
  /**
   * Shutdown on Disconnect is not supported by the OS.
   */
  IdleShutdownMode["NotSupported"] = "NotSupported";
})(IdleShutdownMode = exports.IdleShutdownMode || (exports.IdleShutdownMode = {}));
/**
 * Defines values for PublishingState.
 * Possible values include: 'Draft', 'Publishing', 'Published',
 * 'PublishFailed', 'Scaling'
 * There could be more values for this enum apart from the ones defined here.If
 * you want to set a value that is not from the known values then you can do
 * the following:
 * let param: PublishingState =
 * <PublishingState>"someUnknownValueThatWillStillBeValid";
 * @readonly
 * @enum {string}
 */
var PublishingState;
(function (PublishingState) {
  /**
   * Initial state of an environment setting.
   */
  PublishingState["Draft"] = "Draft";
  /**
   * Currently provisioning resources.
   */
  PublishingState["Publishing"] = "Publishing";
  /**
   * All resources are currently provisioned.
   */
  PublishingState["Published"] = "Published";
  /**
   * Failed to provision all the necessary resources.
   */
  PublishingState["PublishFailed"] = "PublishFailed";
  /**
   * Currently provisioning resources without recreating VM image.
   */
  PublishingState["Scaling"] = "Scaling";
})(PublishingState = exports.PublishingState || (exports.PublishingState = {}));
/**
 * Defines values for UploadState.
 * Possible values include: 'Succeeded', 'InProgress', 'Failed'
 * There could be more values for this enum apart from the ones defined here.If
 * you want to set a value that is not from the known values then you can do
 * the following:
 * let param: UploadState =
 * <UploadState>"someUnknownValueThatWillStillBeValid";
 * @readonly
 * @enum {string}
 */
var UploadState;
(function (UploadState) {
  /**
   * Indicates that the upload operation is in Succeeded state
   */
  UploadState["Succeeded"] = "Succeeded";
  /**
   * Indicates the upload operation is still ongoing
   */
  UploadState["InProgress"] = "InProgress";
  /**
   * Indicates that the upload operation has failed
   */
  UploadState["Failed"] = "Failed";
})(UploadState = exports.UploadState || (exports.UploadState = {}));
/**
 * Defines values for ConfigurationState.
 * Possible values include: 'NotApplicable', 'Completed'
 * There could be more values for this enum apart from the ones defined here.If
 * you want to set a value that is not from the known values then you can do
 * the following:
 * let param: ConfigurationState =
 * <ConfigurationState>"someUnknownValueThatWillStillBeValid";
 * @readonly
 * @enum {string}
 */
var ConfigurationState;
(function (ConfigurationState) {
  /**
   * User either hasn't started configuring their template
   * or they haven't started the configuration process.
   */
  ConfigurationState["NotApplicable"] = "NotApplicable";
  /**
   * User is finished modifying the template.
   */
  ConfigurationState["Completed"] = "Completed";
})(ConfigurationState = exports.ConfigurationState || (exports.ConfigurationState = {}));
/**
 * Defines values for OsType.
 * Possible values include: 'Windows', 'Linux'
 * There could be more values for this enum apart from the ones defined here.If
 * you want to set a value that is not from the known values then you can do
 * the following:
 * let param: OsType = <OsType>"someUnknownValueThatWillStillBeValid";
 * @readonly
 * @enum {string}
 */
var OsType;
(function (OsType) {
  /**
   */
  OsType["Windows"] = "Windows";
  /**
   */
  OsType["Linux"] = "Linux";
})(OsType = exports.OsType || (exports.OsType = {}));
/**
 * Defines values for GpuDriverState.
 * Possible values include: 'NotApplicable', 'Installing', 'Succeeded',
 * 'Failed', 'Missing'
 * There could be more values for this enum apart from the ones defined here.If
 * you want to set a value that is not from the known values then you can do
 * the following:
 * let param: GpuDriverState =
 * <GpuDriverState>"someUnknownValueThatWillStillBeValid";
 * @readonly
 * @enum {string}
 */
var GpuDriverState;
(function (GpuDriverState) {
  /**
   * Initial state of an environment setting.
   */
  GpuDriverState["NotApplicable"] = "NotApplicable";
  /**
   * Currently installing GPU driver extension.
   */
  GpuDriverState["Installing"] = "Installing";
  /**
   * GPU driver extension successfully installed.
   */
  GpuDriverState["Succeeded"] = "Succeeded";
  /**
   * Failed to install GPU driver extension.
   */
  GpuDriverState["Failed"] = "Failed";
  /**
   * User needs to install it manually.
   */
  GpuDriverState["Missing"] = "Missing";
})(GpuDriverState = exports.GpuDriverState || (exports.GpuDriverState = {}));
/**
 * Defines values for Availability.
 * Possible values include: 'Unavailable', 'Available'
 * There could be more values for this enum apart from the ones defined here.If
 * you want to set a value that is not from the known values then you can do
 * the following:
 * let param: Availability =
 * <Availability>"someUnknownValueThatWillStillBeValid";
 * @readonly
 * @enum {string}
 */
var Availability;
(function (Availability) {
  /**
   * Currently unavailable for use.
   */
  Availability["Unavailable"] = "Unavailable";
  /**
   * Currently available for use.
   */
  Availability["Available"] = "Available";
})(Availability = exports.Availability || (exports.Availability = {}));
/**
 * Defines values for GpuType.
 * Possible values include: 'None', 'Gpu'
 * There could be more values for this enum apart from the ones defined here.If
 * you want to set a value that is not from the known values then you can do
 * the following:
 * let param: GpuType = <GpuType>"someUnknownValueThatWillStillBeValid";
 * @readonly
 * @enum {string}
 */
var GpuType;
(function (GpuType) {
  /**
   * No GPU is included.
   */
  GpuType["None"] = "None";
  /**
   * A GPU is included.
   */
  GpuType["Gpu"] = "Gpu";
})(GpuType = exports.GpuType || (exports.GpuType = {}));
/**
 * Defines values for LabUserAccessMode.
 * Possible values include: 'Restricted', 'Open'
 * There could be more values for this enum apart from the ones defined here.If
 * you want to set a value that is not from the known values then you can do
 * the following:
 * let param: LabUserAccessMode =
 * <LabUserAccessMode>"someUnknownValueThatWillStillBeValid";
 * @readonly
 * @enum {string}
 */
var LabUserAccessMode;
(function (LabUserAccessMode) {
  /**
   * Only users registered with the lab can access VMs.
   */
  LabUserAccessMode["Restricted"] = "Restricted";
  /**
   * Any user can register with the lab and access its VMs.
   */
  LabUserAccessMode["Open"] = "Open";
})(LabUserAccessMode = exports.LabUserAccessMode || (exports.LabUserAccessMode = {}));
/**
 * Defines values for DismissState.
 * Possible values include: 'NotDismissed', 'Dismissed'
 * There could be more values for this enum apart from the ones defined here.If
 * you want to set a value that is not from the known values then you can do
 * the following:
 * let param: DismissState =
 * <DismissState>"someUnknownValueThatWillStillBeValid";
 * @readonly
 * @enum {string}
 */
var DismissState;
(function (DismissState) {
  /**
   * Indicates a not dismissed state
   */
  DismissState["NotDismissed"] = "NotDismissed";
  /**
   * Indicates a dismissed state
   */
  DismissState["Dismissed"] = "Dismissed";
})(DismissState = exports.DismissState || (exports.DismissState = {}));
/**
 * Defines values for RecurrenceFrequency.
 * Possible values include: 'Daily', 'Weekly'
 * There could be more values for this enum apart from the ones defined here.If
 * you want to set a value that is not from the known values then you can do
 * the following:
 * let param: RecurrenceFrequency =
 * <RecurrenceFrequency>"someUnknownValueThatWillStillBeValid";
 * @readonly
 * @enum {string}
 */
var RecurrenceFrequency;
(function (RecurrenceFrequency) {
  /**
   * Run every day.
   */
  RecurrenceFrequency["Daily"] = "Daily";
  /**
   * Run every week on the specified days of the week.
   */
  RecurrenceFrequency["Weekly"] = "Weekly";
})(RecurrenceFrequency = exports.RecurrenceFrequency || (exports.RecurrenceFrequency = {}));
/**
 * Defines values for ScheduleActionType.
 * Possible values include: 'Start', 'Stop'
 * There could be more values for this enum apart from the ones defined here.If
 * you want to set a value that is not from the known values then you can do
 * the following:
 * let param: ScheduleActionType =
 * <ScheduleActionType>"someUnknownValueThatWillStillBeValid";
 * @readonly
 * @enum {string}
 */
var ScheduleActionType;
(function (ScheduleActionType) {
  /**
   * Starts the target resource.
   * Behavior depends on the target resource type.
   */
  ScheduleActionType["Start"] = "Start";
  /**
   * Stops the target resource.
   * Behavior depends on the target resource type.
   */
  ScheduleActionType["Stop"] = "Stop";
})(ScheduleActionType = exports.ScheduleActionType || (exports.ScheduleActionType = {}));
/**
 * Defines values for DefaultState.
 * Possible values include: 'NotDefault', 'Default'
 * There could be more values for this enum apart from the ones defined here.If
 * you want to set a value that is not from the known values then you can do
 * the following:
 * let param: DefaultState =
 * <DefaultState>"someUnknownValueThatWillStillBeValid";
 * @readonly
 * @enum {string}
 */
var DefaultState;
(function (DefaultState) {
  /**
   * Indicates it's not the default resource
   */
  DefaultState["NotDefault"] = "NotDefault";
  /**
   * Indicates it's the default resource
   */
  DefaultState["Default"] = "Default";
})(DefaultState = exports.DefaultState || (exports.DefaultState = {}));
/**
 * Defines values for ImageType.
 * Possible values include: 'Generalized', 'Specialized'
 * There could be more values for this enum apart from the ones defined here.If
 * you want to set a value that is not from the known values then you can do
 * the following:
 * let param: ImageType = <ImageType>"someUnknownValueThatWillStillBeValid";
 * @readonly
 * @enum {string}
 */
var ImageType;
(function (ImageType) {
  /**
   * Indicates the image has been generalized
   */
  ImageType["Generalized"] = "Generalized";
  /**
   * Indicates the image has not been generalized
   */
  ImageType["Specialized"] = "Specialized";
})(ImageType = exports.ImageType || (exports.ImageType = {}));
/**
 * Defines values for RegistrationState.
 * Possible values include: 'NotRegistered', 'Registered'
 * There could be more values for this enum apart from the ones defined here.If
 * you want to set a value that is not from the known values then you can do
 * the following:
 * let param: RegistrationState =
 * <RegistrationState>"someUnknownValueThatWillStillBeValid";
 * @readonly
 * @enum {string}
 */
var RegistrationState;
(function (RegistrationState) {
  /**
   * User is not registered with the lab.
   */
  RegistrationState["NotRegistered"] = "NotRegistered";
  /**
   * User is registered with the lab.
   */
  RegistrationState["Registered"] = "Registered";
})(RegistrationState = exports.RegistrationState || (exports.RegistrationState = {}));
/**
 * Defines values for RegistrationLinkEmailState.
 * Possible values include: 'Sent', 'Sending', 'NotSent', 'Failed'
 * There could be more values for this enum apart from the ones defined here.If
 * you want to set a value that is not from the known values then you can do
 * the following:
 * let param: RegistrationLinkEmailState =
 * <RegistrationLinkEmailState>"someUnknownValueThatWillStillBeValid";
 * @readonly
 * @enum {string}
 */
var RegistrationLinkEmailState;
(function (RegistrationLinkEmailState) {
  /**
   * An email has been sent to the user.
   */
  RegistrationLinkEmailState["Sent"] = "Sent";
  /**
   * An email is being process to be sent to the user.
   */
  RegistrationLinkEmailState["Sending"] = "Sending";
  /**
   * An email has not been sent to the user.
   */
  RegistrationLinkEmailState["NotSent"] = "NotSent";
  /**
   * An email has failed to be sent to the user.
   */
  RegistrationLinkEmailState["Failed"] = "Failed";
})(RegistrationLinkEmailState = exports.RegistrationLinkEmailState || (exports.RegistrationLinkEmailState = {}));